import React, { useEffect, useState } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import UnderHeader from "../components/UnderHeader"
import * as queryString from "query-string"
import { StaticImage } from "gatsby-plugin-image"

export const AppButtoniOS = () => {
  return (
    <a
      target="_blank"
      title="Link to download BoatLink mobile iOS App "
      href="https://apps.apple.com/us/app/id1564729906"
    >
      <StaticImage
        className="download-img"
        src={"../assets/AppleStoreButton.png"}
        alt={"Apple Store button to download BoatLink App"}
        placeholder="blurred"
        loading="lazy"
        quality={75}
      />
    </a>
  )
}
export const AppButtonAndorid = () => {
  return (
    <a
      target="_blank"
      title="Link to download BoatLink mobile Android App"
      href="https://play.google.com/store/apps/details?id=com.boatlinkapp"
    >
      {/*<img className="download-img" src={"../assets/GooglePlayButton.png"} />*/}
      <StaticImage
        className="download-img"
        src={"../assets/GooglePlayButton.png"}
        alt={"Google PlayStore button to download BoatLink App"}
        placeholder="blurred"
        loading="lazy"
        quality={50}
      />
    </a>
  )
}

export const AppButtoniOSWhite = () => {
  return (
    <a
      target="_blank"
      title="Link to download BoatLink mobile iOS App "
      href="https://apps.apple.com/us/app/id1564729906"
    >
      <StaticImage
        className="download-img"
        src={"../assets/AppleStoreWhite.png"}
        alt={"Apple Store button to download BoatLink App"}
        placeholder="blurred"
        loading="lazy"
        quality={50}
      />
    </a>
  )
}
export const AppButtonAndoridWhite = () => {
  return (
    <a
      target="_blank"
      title="Link to download BoatLink mobile Android App"
      href="https://play.google.com/store/apps/details?id=com.boatlinkapp"
    >
      <StaticImage
        className="download-img"
        src={"../assets/PlayStoreWhite.png"}
        alt={"Google PlayStore button to download BoatLink App"}
        placeholder="blurred"
        loading="lazy"
        quality={50}
      />
    </a>
  )
}

const DownloadAppPage = ({ location }) => {
  const [noApp, setNoApp] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 1)
    const noApp = queryString.parse(location.search).noapp
    if (noApp) {
      setNoApp(true)
    }
  }, [])
  return (
    <Layout headerType="withSearch" footerType="" footerPage="download">
      <UnderHeader
        title="Get BoatLink App"
        desc="Download our mobile app to book boats and manage your boat rentals"
      />
      {noApp && (
        <div className="container">
          <div className="red-color-text text-center mt-40 mb-40 " role="alert">
            <h5>
              Please install the mobile app to continue your booking request
            </h5>
          </div>
        </div>
      )}
      <div className="container">
        <div className={"row "}>
          {/*<h5 className="banner-bottom-text mb-20 mt-15 text-center">*/}
          {/*  This app is available only on the App Store for iPhone. Android*/}
          {/*  coming soon!*/}
          {/*</h5>*/}
          <div
            className="d-flex download-img-wrapper mb-80 justify-content-center"
            style={{ gap: 10 }}
          >
            <AppButtoniOS />
            <AppButtonAndorid />
          </div>
        </div>
      </div>

      <SEO title="Get BoatLink App" />
    </Layout>
  )
}

export default DownloadAppPage
